import React, { useMemo } from "react"
import styled from "styled-components"
import { Grid } from "../../elements"
import { Container, Title, Description, Button } from "."
import astGetCustomField from "../../utils/astGetCustomField"

type CtaLargeWithImageProps = {
  cta: {
    node: {
      id: string
      title: string
      slug: string
      feature_image: string
      childHtmlRehype: {
        htmlAst: any
      }
    }
  }
}

const CtaLargeWithImage: React.FC<CtaLargeWithImageProps> = ({ cta }) => {
  const htmlAst = cta?.node?.childHtmlRehype?.htmlAst
  const ctaHtmlAst = useMemo(() => {
    return htmlAst?.children?.find(
      child => child.tagName === "cta-large-with-image"
    )
  }, [htmlAst?.children])

  const ctaTitle = useMemo(() => astGetCustomField(ctaHtmlAst, "title"), [
    ctaHtmlAst,
  ])
  const ctaDescription = useMemo(
    () => astGetCustomField(ctaHtmlAst, "description"),
    [ctaHtmlAst]
  )
  const ctaLink = useMemo(() => astGetCustomField(ctaHtmlAst, "link"), [
    ctaHtmlAst,
  ])
  const ctaButtonText = useMemo(
    () => astGetCustomField(ctaHtmlAst, "buttonText"),
    [ctaHtmlAst]
  )
  const ctaImageAltText = useMemo(
    () => astGetCustomField(ctaHtmlAst, "imageAltText"),
    [ctaHtmlAst]
  )
  const ctaImage = cta?.node?.feature_image

  return (
    <ContainerStyled className="not-prose">
      {!!ctaLink && (
        <Grid
          gridTemplateColumns={["1fr", "269px auto"]}
          minHeight="239px"
          borderBottom="none"
          position="relative"
        >
          {!!ctaImage && (
            <Image>
              <img src={ctaImage} alt={ctaImageAltText || " "} />
            </Image>
          )}
          <Content>
            {!!ctaTitle && <Title>{ctaTitle}</Title>}
            {!!ctaDescription && <Description>{ctaDescription}</Description>}
            {!!ctaButtonText && <Button>{ctaButtonText}</Button>}
          </Content>
          <Link
            href={ctaLink}
            data-cta-title={ctaTitle || ""}
            data-cta-description={ctaDescription || ""}
            data-cta-button-text={ctaButtonText || ""}
            data-cta-image-alt-text={ctaImageAltText || ""}
          />
        </Grid>
      )}
    </ContainerStyled>
  )
}

const Link = styled.a`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-bottom: none !important;
`

const Image = styled.div`
  height: 100%;
  max-height: 275px;

  img {
    height: 100%;
    object-fit: cover;
    width: 100%;
    border-radius: 0;
  }
`

const Content = styled.div`
  padding: 30px 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  @media (min-width: ${props => props.theme.breakpointsObj.sm}) {
    padding: 40px;
  }
`

const ContainerStyled = styled(Container)`
  &:hover {
    background: #ffffff;
    box-shadow: 0 0 0px 1px #03192d;
  }
`

export default CtaLargeWithImage
